import { render } from "./VerLogSolicitud.vue?vue&type=template&id=013dd9ae"
import script from "./VerLogSolicitud.vue?vue&type=script&lang=js"
export * from "./VerLogSolicitud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__